import AgyleToggleButtons from "../../../components/ui/buttons/agyleToggleButtons";
import React, {useEffect, useState} from 'react';
import {admissionStatusTypes, admissionViewTypes, bookAdmissionToggleStyles} from '../bookedAdmissions';
import Grid from "@mui/material/Grid";
import AgyleButton from "../../../components/ui/buttons/agyleButton";
import {Add} from "@mui/icons-material";
import AgyleSelectField from "../../../components/ui/selector/agyleSelectField";
import AgyleSimpleSearchField from "../../../components/ui/search/agyleSimpleSearchField";
import AgyleMenuIcon from "../../../components/header/agyleMenu/agyleMenuIcon";
import makeStyles from "@mui/styles/makeStyles";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    clearFilters,
    getAdmissionType, getConfig, getInitRenderCalendar,
    getOperationsStatus,
    getSelectedTheatre, getStartDay,
    getTheatresDict, setDraftModeOn, setInitRenderCalendar,
    setMarkedOperation,
    setNewAdmissionType, setNewStartDay,
    setOperationToScroll,
    setSelectedTheatre,
} from '../../../store/reducers/booked_admissions';
import AgyleDialog from "../../../components/modal/agyleDialog";
import useOpenState from "../../../hooks/useOpenState";
import SessionModal from "./sessionModal";
import Settings from "@mui/icons-material/Settings";
import PrintIcon from '@mui/icons-material/Print';
import SettingsModal from "./settingsModal";
import PrintModal from './printModal';
import PatientsSearch from './patientsSearch';
import DashboardIcon from '@mui/icons-material/Dashboard';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {hasBAPermission, hasPermission, Permissions} from '../../../store/reducers/user';
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Close';
import * as PropTypes from 'prop-types';
import MySessionModal from './mySessionModal';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import {agylePref} from '../../../store/reducers/preferences';
import IconButton from '@mui/material/IconButton';
import {CENTRAL_PAGE_PATH} from '../../centralPage/constants';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const useStyles = makeStyles((theme) => ({
    rowDiv: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        "&.marginLeft": {
            marginLeft: 5,
        },
    },
    item: {
        display: "flex",
        alignItems: "center",
        margin: "0 5px 0 5px",
    },
    itemTheaters: {
        display: "flex",
        alignItems: "center",
        margin: "0 5px 0 5px",
        width: 200
    },
    searchItem: {
        marginLeft: 40,
        background: theme.palette.background.default,
        width: "300px",
        display: "inline-flex",
        zIndex: 1010,
        paddingLeft: "10px",
        borderRadius: "10px 10px 0 0",
        justifyContent: "space-between",
        alignItems: "center"
    },
    clearButton: {
        color: "#2180F7",
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer"
    },
    closeButton: {
        fontSize: 12,
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer"
    },
    searchItemNoArrow: {
        background: theme.palette.background.default,
        width: "300px",
        display: "inline-flex",
        zIndex: 1010,
        marginLeft: "74px",
        paddingLeft: "10px",
        borderRadius: "10px 10px 0 0",
        justifyContent: "space-between",
        alignItems: "center"

    },
    openState: {
        background: theme.palette.background.defaultBackground,
        width: "calc(100vw - 68px - 55px - 58px)",
        position: "absolute",
        left: 68,
        paddingRight: 5,
        border: "1px solid white",
        borderBottom: "none"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#f2f2f2"
    },
    iconButton: {
        margin: "0px 10px",
        cursor: 'pointer'
    }
}));

export const HeaderPrintModal = (props) => {
    return (<AgyleDialog
      title={"Print"}
      open={props.isPrintModalOpen || props.open}
      onClose={props.closePrintModal || props.onClose}
      width={"lg"}
      fullWidth={props.fullWidth}
      fullScreen={props.fullScreen}
      disableActions={props.disableActions}
      closeButtonOnHeader={props.closeButtonOnHeader}
      contentStyle={props.dialogContentStyle}
    >
        <PrintModal
          admissionType={props.admissionType}
          admissionStatus={props.admissionStatus}
          onlyPatient={props.onlyPatient}
        />
    </AgyleDialog>)
}

const BookedAdmissionsHeader = (props) => {
    const classes = useStyles();
    const baToggleClasses = bookAdmissionToggleStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedTheatre = useSelector(getSelectedTheatre);
    const admissionType = useSelector(getAdmissionType);
    const theatres = useSelector(getTheatresDict);
    const startDay = useSelector(getStartDay);
    const config = useSelector(getConfig);
    const agylePreference = useSelector(agylePref);
    const canPrint = dispatch(hasBAPermission(Permissions.BA_CAN_PRINT));
    const [isNewSessionModalOpen, openNewSessionModal, closeNewSessionModal] = useOpenState(false, true);
    const [isSettingsModalOpen, openSettingsModal, closeSettingsModal] = useOpenState(false, true);
    const [isPrintModalOpen, openPrintModal, closePrintModal] = useOpenState(false, true);

    const [isUserModalOpen, openUserModal, closeUserModal] = useOpenState(false, true);

    const [searchPhrase, setSearchPhrase] = React.useState("");
    const [openSearchModal, setOpenSearchModal] = useState(false);

    const initRender = useSelector(getInitRenderCalendar);

    const openMySessionModal = (open) => {
        if(initRender && open && !isSettingsModalOpen) {
            openUserModal();
            dispatch(setInitRenderCalendar(false))
        }
    }

    useEffect(() => {
        if(agylePreference.loadedFromApi && agylePreference.bookedAdmissions?.landingPage){
            openMySessionModal(agylePreference?.bookedAdmissions?.landingPage === "mySessions")
        } else if(config){
            openMySessionModal(config?.defaultLandingPage === "mySessions")
        }
    }, [agylePreference.loadedFromApi, config]);

    const renderCustomOption = (opt) => {
        let desc = opt.description;

        return (
            <MenuItem
                key={opt.__id}
                value={opt}
            >
                {desc} {opt.active? "" : "(inactive)"}
            </MenuItem>
        );
    };

    const handleOnFocusSearch = () => {
        dispatch(clearFilters());
        setOpenSearchModal(true);
    }
    const handleCloseDropdown = () => {
        setOpenSearchModal(false);
    }

    const [iFrameView] = React.useState(props.isFrame);

    const admissionStatus = useSelector(getOperationsStatus);

    const getAdmissionTypeList = () => {
        let s = [{value: admissionViewTypes.THEATRES, label: "THEATRES"}];
        if(admissionStatus !== admissionStatusTypes.WORKLIST) s.push({value: admissionViewTypes.MDU, label: "MDU"});
        return s
    }

    const goToDashboard = () => {
        if(!config.hasOwnProperty("dashboard") || !config.dashboard.hasOwnProperty("timeRange") || config.dashboard.timeRange == "week"){
            dispatch(setNewStartDay(moment(startDay).startOf('week')));
        }
        history.push("/bookedAdmissionsDashboard")
    }


    const canAddNewSession = () => {
        if(admissionStatus === admissionStatusTypes.WORKLIST) return false;
        if(admissionViewTypes.THEATRES === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_ADD_NEW_T_SESSION, admissionType));
        if(admissionViewTypes.MDU === admissionType) return dispatch(hasBAPermission(Permissions.BA_CAN_ADD_MDU_SESSION, admissionType));
    }


    const getTheatres = () => {
        if(agylePreference.bookedAdmissions?.inactiveTheatres !== null)
            return agylePreference.bookedAdmissions?.inactiveTheatres? theatres: theatres.filter((t) => t.active === true);
        else return config.inactiveTheatres? theatres: theatres.filter((t) => t.active === true);
    }

    return (
        <Grid container direction="row" justifyContent={"space-between"} style={{marginBottom: 10}}>
            <div className={classes.rowDiv}>
                {!iFrameView &&
                    <div className={classes.item}>
                        <AgyleMenuIcon/>
                    </div>
                }
                {props.goToMain &&
                    <div className={classes.item}>
                        <IconButton onClick={() => history.push(CENTRAL_PAGE_PATH)}>
                            <ArrowBackIcon/>
                        </IconButton>
                    </div>
                }
                <div className={clsx((props.goToMain ? classes.searchItem : classes.searchItemNoArrow), openSearchModal && classes.openState)}>
                    <div style={{width: "inherit"}}>
                        <AgyleSimpleSearchField
                            value={searchPhrase}
                            size={"small"}
                            margin={"none"}
                            searchIconSize={"small"}
                            handleOnFocus={handleOnFocusSearch}
                            onChange={setSearchPhrase}
                            placeholder={"Search Patient..."}
                        />
                    </div>

                    <div style={{display: "inline-flex", gap: 15, marginRight: 5}}>
                        {searchPhrase.length !== 0 && <div className={classes.clearButton} onClick={()=>{setSearchPhrase("")}}> Clean </div>}
                        {openSearchModal && <div className={classes.closeButton} onClick={()=>{setOpenSearchModal(false)}}>  <CloseIcon fontSize={"small"}/> </div>}
                    </div>
                </div>

            </div>
            <div className={classes.rowDiv}>
                <div className={classes.item}>
                    <AgyleToggleButtons
                        classNameRoot={baToggleClasses.baToggle_classNameRoot}
                        classNameLabel={baToggleClasses.baToggle_classNameLabel}
                        classNameSelected={baToggleClasses.baToggle_classNameSelected}
                        onChange={(e) => {
                            if(e) {
                                dispatch(setMarkedOperation(null))
                                dispatch(setOperationToScroll(null))
                                dispatch(setNewAdmissionType(e));
                            }

                        }}
                        value={admissionType}
                        size="small"
                        options={getAdmissionTypeList()}
                        minWidth={100}
                    />
                </div>

                {admissionStatus !== admissionStatusTypes.WORKLIST && <div className={classes.itemTheaters}>
                   <AgyleSelectField
                       onChange={ (e) => {
                           dispatch(setDraftModeOn(false));
                           dispatch(setSelectedTheatre(e));
                       }}
                       options={getTheatres()}
                       value={selectedTheatre}
                       withBorder
                       defaultClearValue={null}
                       customObject={renderCustomOption}
                       clearButtonVisible={false}
                   />
               </div>}

               <div className={classes.item}>
                   <AgyleButton
                       colour={baToggleClasses.baButton_classNamePrimary}
                       onClick={openNewSessionModal}
                       startIcon={<Add/>}
                       disabled={!canAddNewSession()}
                       variant={"contained"}
                   >
                       Add session
                   </AgyleButton>

                       <DashboardIcon onClick={() => {
                           goToDashboard()
                       }} className={classes.iconButton}/>

                   <RecentActorsIcon  onClick={openUserModal} className={classes.iconButton}/>

                   {canPrint &&
                        <PrintIcon onClick={openPrintModal} className={classes.iconButton}/>
                   }

                   <Settings onClick={openSettingsModal} className={classes.iconButton}/>
               </div>

                <AgyleDialog
                    title={admissionType === admissionViewTypes.THEATRES? "Create New Session" : "Add new MDU Session"}
                    open={isNewSessionModalOpen}
                    onClose={closeNewSessionModal}
                    width={"lg"}
                    fullWidth
                    contentStyle={classes.dialogContentStyle}
                    disableActions
                    closeButtonOnHeader
                >
                    <SessionModal onClose={closeNewSessionModal}/>
                </AgyleDialog>

                <AgyleDialog
                    title={"SETTINGS"}
                    open={isSettingsModalOpen}
                    onClose={closeSettingsModal}
                    width={"lg"}
                    contentStyle={classes.dialogContentStyle}
                    fullWidth
                    fullScreen
                    disableActions
                    closeButtonOnHeader
                >
                    <SettingsModal />

                </AgyleDialog>

                <AgyleDialog
                    title={"My Sessions in next 4 weeks"}
                    open={isUserModalOpen}
                    onClose={closeUserModal}
                    width={"lg"}
                    contentStyle={classes.dialogContentStyle}
                    fullWidth
                    fullScreen
                    disableActions
                    closeButtonOnHeader
                >

                <MySessionModal closeUserModal={closeUserModal}/>

                </AgyleDialog>

                {canPrint &&
                    <HeaderPrintModal
                        title={"Print"}
                        open={isPrintModalOpen}
                        onClose={closePrintModal}
                        width={"lg"}
                        fullWidth
                        fullScreen
                        disableActions
                        closeButtonOnHeader
                        admissionType={admissionType}
                        admissionStatus={admissionStatus}
                        dialogContentStyle={classes.dialogContentStyle}
                    />
                }
                <PatientsSearch searchPhrase={searchPhrase} open={openSearchModal} openSearchModal={handleCloseDropdown}/>
            </div>

        </Grid>
    )
};

export default BookedAdmissionsHeader